import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
   DashboardRiskDailyBreakdownResponse,
   DashboardRiskReportTypeResponse,
   DashboardRiskSeverity
} from '../../../services/response/user-property-dashboard-response';
import { TableModule } from 'primeng/table';

@Component({
   selector: 'app-dashboard-risk-breakdown',
   standalone: true,
   imports: [CommonModule, TableModule],
   templateUrl: './risk-breakdown.component.html',
   styleUrls: ['./risk-breakdown.component.scss']
})
export class RiskBreakdownComponent {
   @Input() report: DashboardRiskReportTypeResponse | null = null;

   @Output() viewTask = new EventEmitter<number>();

   isFinancialReport(): boolean {
      return (this.report?.financialRiskCount ?? 0) > 0;
   }

   formatCurrency(value: number | null | undefined): string {
      return new Intl.NumberFormat('en-AU', {
         style: 'currency',
         currency: 'AUD',
         minimumFractionDigits: 2,
         maximumFractionDigits: 2
      }).format(value ?? 0);
   }

   formatOperationalRisks(count: number): string {
      return `${count} ${count === 1 ? 'risk' : 'risks'}`;
   }

   formatBusinessDate(date: string): string {
      const [year, month, day] = date.split('-');

      return `${day}/${month}/${year}`;
   }

   getSeverityClass(severity: DashboardRiskSeverity | null): string {
      switch (severity) {
         case 'HIGH':
            return 'risk-severity-high';

         case 'MEDIUM':
            return 'risk-severity-medium';

         case 'WARNING':
            return 'risk-severity-warning';

         case 'LOW':
            return 'risk-severity-low';

         default:
            return 'risk-severity-none';
      }
   }

   onViewTask(day: DashboardRiskDailyBreakdownResponse): void {
      if (day.taskInstanceId === null) {
         return;
      }

      this.viewTask.emit(day.taskInstanceId);
   }
}
